import React, { useEffect, useState } from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { AuthHelper, ICognitoDevice } from '../../helpers/AuthHelper';
import './TrustedDevices.scss';

export const TrustedDevices = (): JSX.Element => {
  const [devices, setDevices] = useState<ICognitoDevice[]|null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setError('');
    AuthHelper.listDevices()
      .then(setDevices)
      .catch(err => {
        console.error('Failed to list devices', err);
        setError('Ophalen vertrouwde apparaten mislukt.');
      });
  }, []);

  const handleForgetDevice = (deviceKey: string): void => {
    if (!devices) {
      return;
    }

    setError('');

    const devicesCopy = [...devices];
    const index = devicesCopy.findIndex(item => item.DeviceKey === deviceKey);
    devicesCopy.splice(index, 1);
    setDevices(devicesCopy);

    AuthHelper.forgetDevice(deviceKey)
      .catch(err => {
        console.error('Failed to forget device', err);
        setError('Apparaat vergeten mislukt.');
        setDevices(devices);
      });
  };

  const renderDeviceDetails = (device: ICognitoDevice): JSX.Element => {
    const { Value: name } = device.DeviceAttributes.find(att => att.Name === 'device_name') || {};
    const { Value: ip } = device.DeviceAttributes.find(att => att.Name === 'last_ip_used') || {};
    const addedAt = new Date(Math.floor(device.DeviceCreateDate * 1000)).toLocaleString();

    return <div className="trusted-devices__device-details">
      <span className="trusted-devices__device-name">{name}</span><br/>
      IP: <span className="trusted-devices__device-ip">{ip}</span><br/>
      Toegevoegd op: <span className="trusted-devices__device-added-at">{addedAt}</span>
    </div>;
  };

  const renderDevices = (): JSX.Element => {
    if (!devices) {
      return <Spinner variant="primary" animation="border" />;
    }

    if (devices.length === 0) {
      return <Alert variant="info">Je hebt geen vertrouwde apparaten</Alert>;
    }

    return <li className="trusted-devices__devices">
      { devices.map(device => <li key={device.DeviceKey} className="trusted-devices__device">
        { renderDeviceDetails(device) }
        <Button onClick={() => handleForgetDevice(device.DeviceKey)}>Apparaat vergeten</Button>
      </li>)}
    </li>;
  };

  return <div className="trusted-devices">
    <h3>Vertrouwde apparaten</h3>
    { error && <Alert variant="danger">{error}</Alert> }
    { renderDevices() }
  </div>;
};
